module.exports = __webpack_public_path__ + "files/c8badd2cd46d1f346bb95a1bb7fc05f4.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/solarized-light.png
// module id = 582
// module chunks = 60